<template>
  <div id="app">
    <router-view v-slot="{ Component }">
      <transition name="fade" mode="out-in">
        <component :is="Component" />
      </transition>
    </router-view>
  </div>
</template>

<script>
export default {
  name: 'App',
}
</script>

<style>
/* 全局样式 */
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

/* 品牌色与设计令牌：统一主题色，避免各页面散落硬编码 */
:root {
  --color-primary: #009688;       /* 主绿 */
  --color-primary-dark: #00796b;  /* 深绿：hover/激活态 */
  --color-primary-light: #4CAF50; /* 浅绿：辅助/渐变 */
  --color-text: #333;
  --color-text-muted: #666;
  --transition-fast: 200ms ease;
  --transition-base: 300ms ease;
}

body {
  font-family: "Helvetica Neue", Arial, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #333;
  line-height: 1.6;
  font-size: 16px;
  overflow-x: hidden;
}

#app {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
}

/* 响应式断点 */
/* 移动设备 - 小屏幕 */
@media (max-width: 480px) {
  body {
    font-size: 14px;
  }
  
  .container {
    padding: 0 15px;
  }
}

/* 移动设备 - 中等屏幕 */
@media (min-width: 481px) and (max-width: 767px) {
  body {
    font-size: 15px;
  }
  
  .container {
    padding: 0 20px;
  }
}

/* 平板设备 */
@media (min-width: 768px) and (max-width: 1023px) {
  body {
    font-size: 15px;
  }
  
  .container {
    max-width: 720px;
    margin: 0 auto;
  }
}

/* 小型桌面设备 */
@media (min-width: 1024px) and (max-width: 1279px) {
  .container {
    max-width: 960px;
    margin: 0 auto;
  }
}

/* 大型桌面设备 */
@media (min-width: 1280px) {
  .container {
    max-width: 1200px;
    margin: 0 auto;
  }
}

/* 通用响应式图片 */
img {
  max-width: 100%;
  height: auto;
}

/* 辅助类 */
.text-center {
  text-align: center;
}

.hidden-mobile {
  display: block;
}

.visible-mobile {
  display: none;
}

@media (max-width: 767px) {
  .hidden-mobile {
    display: none;
  }
  
  .visible-mobile {
    display: block;
  }
}

/* 清除浮动 */
.clear {
  clear: both;
}

/* 通用列表样式 */
.list-inline {
  padding-left: 0;
  list-style: none;
  margin-left: -5px;
}

.list-inline > li {
  display: inline-block;
  padding-left: 5px;
  padding-right: 5px;
}

/* 页面切换动画 */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease, transform 0.3s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
  transform: translateY(10px);
}

/* 无障碍：键盘导航时显示清晰的焦点环（鼠标点击不显示，避免视觉噪声） */
a:focus-visible,
button:focus-visible,
input:focus-visible,
textarea:focus-visible,
select:focus-visible,
[tabindex]:focus-visible {
  outline: 2px solid var(--color-primary);
  outline-offset: 2px;
  border-radius: 2px;
}

/* 可点击元素统一手型光标 */
a,
button,
[role="button"] {
  cursor: pointer;
}

/* 尊重系统"减少动态效果"偏好：关闭非必要动画，提升可访问性与舒适度 */
@media (prefers-reduced-motion: reduce) {
  *,
  *::before,
  *::after {
    animation-duration: 0.01ms !important;
    animation-iteration-count: 1 !important;
    transition-duration: 0.01ms !important;
    scroll-behavior: auto !important;
  }
}
</style>
